import moment from 'moment';

export default (
  pnrInfo,
  subFunnel,
  userProfile,
  allPassengers,
  isActiveFlowCorporate,
) => {
  const ffNumber = userProfile?.ffNumber ? `${userProfile?.ffNumber}` : 'NA';
  let ffProgram = null;
  (allPassengers || []).forEach( passenger => {
    if ( passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });
  const tripType = pnrInfo?.flightItineraryType === 'ONEWAY' ? 'OW' : pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? 'RT' : 'MC';

  const segments = [];
  const legCollection = pnrInfo?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;

  legCollection.forEach((element) => {
    const data = element?.segmentsCollection;
    /* eslint-disable no-unused-expressions */
    data?.forEach((segmentsData) => {
      segments.push(segmentsData);
    });
  });

  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';

  const marketOd = `${departureAirport}${arrivalAirport}`; 
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }

  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';

  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';

  const currentDate = moment();
  let outboundDepartureDateTime = null;
  let departureDateOutbound = null;
  let duration = null;
  const validSegment = (segments || []).find( item => {
    outboundDepartureDateTime = item?.departureDateTime;
    departureDateOutbound = moment(outboundDepartureDateTime);
    return departureDateOutbound.isAfter(currentDate);
  });
  let dtd = 'NA';
  if (validSegment) {
    outboundDepartureDateTime = validSegment?.departureDateTime;
    departureDateOutbound = moment(outboundDepartureDateTime);
    duration = moment.duration(departureDateOutbound.diff(currentDate));
    const days = Math.floor(duration?.asDays());
    const hours = duration?.hours();
    const minutes = duration?.minutes();
    dtd = `${days}/${hours}:${minutes}`;
  }
  

  let marketSegments = 'NA';
  let marketSegmentsOutbound = (outboundSegments || []).map(segment => {
    return (`${segment.departureAirport || 'NA'}` + `${segment.arrivalAirport || 'NA'}`);
  });
  let marketSegmentsInbound = inboundSegments.map(segment => {
    return (`${segment.departureAirport || 'NA'}` + `${segment.arrivalAirport || 'NA'}`);
  });

  marketSegmentsOutbound = marketSegmentsOutbound?.length > 1
    ? marketSegmentsOutbound.join('/')
    : marketSegmentsOutbound[0] || 'NA';
 
  marketSegmentsInbound = marketSegmentsInbound?.length > 1
    ? marketSegmentsInbound.join('/')
    : marketSegmentsInbound[0] || 'NA';
 
  marketSegments = pnrInfo?.flightItineraryType === 'ONEWAY' ? marketSegmentsOutbound :
    `${marketSegmentsOutbound}-${marketSegmentsInbound}`;

  const marketCarrier = segments?.map((segment) => segment?.marketingCarrier || 'NA')?.join('-');
  const opCarrier = segments?.map((segment) => segment?.operatingCarrier || 'NA')?.join('-');
  const cabin = segments?.map((segment) => segment?.cabin || 'NA')?.join('-');
  const bookingClass = segments?.map((segment) => segment?.bookingClass || 'NA')?.join('-');

  let adults = 0;
  let adultMinors = 0;
  let child = 0;
  let infants = 0;
  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];

  travelerCollection?.forEach(travelerItem => {
    if (travelerItem?.paxType === 'INFANT') {
      infants = infants + 1;
    } else if (travelerItem?.paxType === 'CHILD') {
      child = child + 1;
    } else if (travelerItem?.paxType === 'ADULT') {
      const dateOfBirth = moment(travelerItem?.dateOfBirth).format('YYYYMMDD');
      const currentAge = moment().diff(moment(dateOfBirth, 'YYYYMMDD'), 'years');
      if (currentAge >= 15 && currentAge < 18) {
        adultMinors = adultMinors + 1;
      } else {
        adults = adults + 1;
      }
    }
  });

  const corpProgram = pnrInfo?.userProfile?.corporateProgram?.corporateNumber;
  const corpSPid = pnrInfo?.clid?.companyNumber;
  const pricePoints = pnrInfo?.confirmationModel?.cartConfirmation?.total?.totalCPPoints || 0;
  const amountSpent = pnrInfo?.confirmationModel?.cartConfirmation?.total?.total || 0;
  const fopType = ( amountSpent != 0 && pricePoints != 0 ) ? 'Both' : ( amountSpent != 0 ) ? 'Cash' : ( pricePoints ? 'Points' : 'NA');

  return {
    'event': 'journey_success',
    'fop_type' : fopType,
    'funnel_name': 'MYB',
    'sub_funnel_name': subFunnel || 'NA',
    'trip_type': tripType || 'NA',
    'market_od': marketOd || 'NA',
    'market_ndod': marketNdod || 'NA',
    'market_segment': marketSegments || 'NA',
    'pnr': pnrInfo?.pnrCode || 'NA',
    'outbound_departure_date': outboundDepartureDate?.format('YYYYMMDD') || 'NA',
    'inbound_departure_date': inboundDepartureDate || 'NA',
    'outbound_arrival_date': outboundArrivalDate || 'NA',
    'inbound_arrival_date': inboundArrivalDate || 'NA',
    'adults': adults,
    'childs': child,
    'adult_minors': adultMinors,
    'infants': infants,
    'ffn_program': ffProgram || 'NA',
    'ffn_id': !isActiveFlowCorporate ? ffNumber : 'NA',
    'corp_program': corpProgram || 'NA',
    'corp_id': isActiveFlowCorporate ? ffNumber : 'NA',
    'corp_discount': 'NA',
    'corp_spid': corpSPid || 'NA',
    'change_type': 'NA',
    'change_reason': 'NA',
    'success_type': 'Success',
    'mkt_carrier': marketCarrier || 'NA',
    'op_carrier': opCarrier || 'NA',
    'hnd_carrier': opCarrier || 'NA',
    'region': legCollection[0]?.regionKey || 'NA',
    'dtd': dtd || 'NA',
    'clid_benefits': 'NA',
    'cabin': cabin || 'NA',
    'class': bookingClass || 'NA',
  };
};